import { render, staticRenderFns } from "./Form2FASettingsSso.vue?vue&type=template&id=70ea3bd1&scoped=true"
import script from "./Form2FASettingsSso.vue?vue&type=script&lang=js"
export * from "./Form2FASettingsSso.vue?vue&type=script&lang=js"
import style0 from "./Form2FASettingsSso.vue?vue&type=style&index=0&id=70ea3bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea3bd1",
  null
  
)

export default component.exports